module.exports = __webpack_public_path__ + "assets/img/ktz_img12.49ab58d0.png";